export const OPERATION_TYPES =[
    "TRANSFER",
    "BANK_CHECK",
    "CASH"
];